<template>
  <div>
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deleteEvents(idpass)"
    />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex h-full relative">
          <div class="relative rounded-3xl w-full">
            <div class="flex justify-end">
              <button
                @click="addevent = true"
                class="bg-blues hover:bg-hover rounded-xl text-white px-4 py-1 mt-2 mr-6 z-40"
              >
                Add Class
              </button>
            </div>

            <vue-cal
              small
              ref="vuecal"
              events-on-month-view="short"
              active-view="month"
              :disable-views="['years', 'year', 'week']"
              :events="values"
              :on-event-click="onEventClick"
              class="rounded-3xl border-none absolute top-0 bottom-0 w-full"
            >
            </vue-cal>
          </div>
        </div>
      </div>

      <div
        v-if="addevent"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[650px]"
        >
          <div
            class="flex items-center justify-between mb-6 pb-4 border-b border-gray-200"
          >
            <div class="flex items-center gap-3">
              <div
                class="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-md"
              >
                <svg
                  class="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </div>
              <div>
                <h3 class="text-xl font-bold text-gray-800">Add New Class</h3>
                <p class="text-xs text-gray-500 mt-0.5">
                  Create a new class and set up details
                </p>
              </div>
            </div>
            
            <button
              @click.prevent="closeAddForm"
              class="p-1 border border-red-500 hover:bg-red-500 hover:border-red-500 rounded-full transition-all duration-200 group"
            >
              <svg
                class="w-5 h-5 text-red-400 group-hover:text-white transition-all duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
          >
            <div class="w-full">
              <form
                ref="ScheduleEvent"
                @submit.prevent="scheduledate"
                class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
              >
                <div
                  class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                >
                  <div class="flex flex-col gap-2">
                    <label for="course_title" class="text-left">
                      Course Title
                    </label>
                    <select
                      id="course_title"
                      v-model="formData.coursetitle_id"
                      required
                      class="w-full p-2 border border-gray-100 rounded bg-white"
                    >
                      <option value="" disabled selected>Select Course</option>
                      <option v-for="el in courses" :key="el.id" :value="el.id">
                        {{ el.title }}
                      </option>
                    </select>
                  </div>
                  <div class="w-full flex flex-col gap-2">
                    <label for="title" class="text-left">Liveclass Title</label>
                    <input
                      id="meetingTitle"
                      type="text"
                      v-model="formData.title"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>
                  <div class="flex flex-col gap-3">
                    <label for="thumbnail" class="text-sm">Thumbnail </label>
                    <input
                      id="thumbnail"
                      type="file"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left">Start Time</label>
                    <input
                      id="meetingDate"
                      type="datetime-local"
                      v-model="formData.startDate"
                      :min="today"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left">End Time</label>
                    <input
                      id="meetingEndDate"
                      type="datetime-local"
                      v-model="formData.endDate"
                      :min="today"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>
                  <div class="w-full flex items-center gap-2">
                    <input
                      id="feedback"
                      type="checkbox"
                      v-model="formData.feedback"
                    />
                    <label
                      for="feedback"
                      class="text-sm font-medium cursor-pointer"
                    >
                      Enable Feedback
                    </label>
                  </div>
                </div>

                <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Meeting URL
                  </label>
                  <div class="flex items-center gap-3 w-full">
                    <input
                      id="meetingUrl"
                      v-model="meetingUrl"
                      type="text"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2 w-[80%]"
                      required
                    />
                    <div v-if="activeZoom">
                      <button
                        @click="generateZoomUrl()"
                        type="button"
                        id="Editurl"
                        :disabled="!isFirst3FieldsFilled"
                        :class="
                          !isFirst3FieldsFilled
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-blues hover:bg-hover cursor-pointer text-white'
                        "
                        class="rounded-xl text-sm p-2 whitespace-nowrap"
                      >
                        Generate URL
                      </button>
                    </div>
                    <div v-else-if="activeTeams">
                      <button
                        v-if="isContainAccessToken"
                        @click="generateMeetingUrl()"
                        type="button"
                        id="Editurl"
                        :disabled="!isFirst3FieldsFilled"
                        :class="
                          !isFirst3FieldsFilled
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-blues hover:bg-hover cursor-pointer text-white'
                        "
                        class="rounded-xl text-sm p-2 whitespace-nowrap"
                      >
                        Generate URL
                      </button>
                      <button
                        v-else
                        type="button"
                        id="Editurl"
                        :disabled="!isButtonEnabled"
                        :class="
                          !isButtonEnabled
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-blues hover:bg-hover cursor-pointer text-white'
                        "
                        class="rounded-xl text-sm p-2 whitespace-nowrap"
                        @click="generateUrl()"
                      >
                        Config Settings
                      </button>
                    </div>
                    <div v-else>
                      <button
                        @click="reDirect()"
                        type="button"
                        :disabled="!isFirst3FieldsFilled"
                        :class="
                          !isFirst3FieldsFilled
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-blues hover:bg-hover cursor-pointer text-white'
                        "
                        class="rounded-xl text-sm p-2 whitespace-nowrap"
                      >
                        Config Settings
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex justify-end items-center gap-3">
                  <button
                    type="submit"
                    :disabled="!isAllFieldsFilled || disable_submit"
                    :class="
                      !isAllFieldsFilled || disable_submit
                        ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : 'hover:bg-hover text-black border border-black cursor-pointer hover:text-white'
                    "
                    class="rounded-lg text-sm px-6 py-2"
                  >
                    Submit
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="popUp"
        class="fixed inset-0 bg-primary bg-opacity-30 z-[100] flex items-center justify-center"
      >
        <div
          class="w-[95%] sm:w-[85%] md:w-[60%] 2xl:w-[40%] bg-white rounded-xl p-4 sm:p-6 md:p-8 lg:p-10 max-h-[90vh] overflow-y-auto transition-all duration-300 ease-out"
        >
          <div
            class="flex items-center justify-between mb-6 pb-4 border-b border-gray-200"
          >
            <div class="flex items-center gap-3">
              <div
                class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-md"
              >
                <svg
                  class="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </div>
              <div>
                <h3 class="text-xl font-bold text-gray-800">Edit Class</h3>
                <p class="text-xs text-gray-500 mt-0.5">
                  Update class information
                </p>
              </div>
            </div>
            <button
              @click="this.popUp = false"
              class="p-1 border border-red-500 hover:bg-red-500 hover:border-red-500 rounded-full transition-all duration-200 group"
            >
              <svg
                class="w-5 h-5 text-red-400 group-hover:text-white transition-all duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            class="flex flex-col gap-4 p-4 border border-gray-100 rounded-2xl"
          >
            <form
              ref="ScheduleEvent"
              @submit.prevent="editEvents"
              class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
            >
              <div
                class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
              >
                <div class="w-full flex flex-col gap-2">
                  <label
                    for="title"
                    class="text-left text-sm font-medium text-gray-700"
                    >Course Title</label
                  >
                  <input
                    id="meetingTitle"
                    type="text"
                    v-model="updatevalues.course_title"
                    class="border border-gray-200 rounded-lg text-xs md:text-sm lg:text-base py-2 px-3 outline-none bg-gray-50 cursor-not-allowed text-gray-600"
                    readonly
                  />
                </div>
                <div class="w-full flex flex-col gap-2">
                  <label for="title" class="text-left">Liveclass Title</label>
                  <input
                    id="meetingTitle"
                    type="text"
                    v-model="updatevalues.title"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="thumbnail" class="text-sm">Thumbnail</label>
                  <input
                    id="thumbnail"
                    type="file"
                    @change="handleFileUpload"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <a
                    v-if="updatevalues.image"
                    :href="updatevalues.image"
                    download
                    target="_blank"
                    class="text-sm text-textblues"
                    >{{ updatevalues.image.split("/").pop() }}</a
                  >
                </div>
                <div class="w-full flex flex-col gap-2">
                  <label for="duedate" class="text-left">Start Time</label>
                  <input
                    id="meetingDate"
                    type="datetime-local"
                    v-model="updatevalues.start_date"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div>

                <div class="w-full flex flex-col gap-2">
                  <label for="duedate" class="text-left">End Time</label>
                  <input
                    id="meetingEnd"
                    type="datetime-local"
                    v-model="updatevalues.end_date"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div>
                <div class="w-full flex items-center gap-2">
                  <input
                    id="feedback"
                    type="checkbox"
                    v-model="updatevalues.feedback"
                  />
                  <label
                    for="feedback"
                    class="text-sm font-medium cursor-pointer"
                  >
                    Enable Feedback
                  </label>
                </div>
              </div>

              <div
                class="flex flex-col w-full"
                :class="{
                  '': !isClassEnded(updatevalues.end_date),
                  'border-gray-300 bg-gray-100 rounded-lg p-3': isClassEnded(
                    updatevalues.end_date,
                  ),
                }"
              >
                <label
                  for="meetingUrledit"
                  class="text-left font-medium mb-2 flex flex-wrap items-center gap-2"
                >
                  Meeting URL
                  <span
                    v-if="isClassEnded(updatevalues.end_date)"
                    class="flex flex-wrap items-center gap-1 text-sm"
                  >
                    (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 text-yellow-500 flex-shrink-0"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Warning:
                    <span class="font-normal">
                      Class Ended ({{ formatDateTime(updatevalues.end_date) }})
                      Generate URL is disabled
                    </span>
                    )
                  </span>
                </label>

                <div class="flex flex-col sm:flex-row gap-3 w-full">
                  <!-- Input field -->
                  <input
                    id="meetingUrledit"
                    type="text"
                    class="border border-gray-100 rounded text-xs sm:text-sm md:text-base py-2 px-2 w-full sm:w-[70%]"
                    v-model="updatevalues.url"
                    :disabled="isClassEnded(updatevalues.end_date)"
                    :class="{
                      'bg-gray-200 cursor-not-allowed': isClassEnded(
                        updatevalues.end_date,
                      ),
                      'bg-white': !isClassEnded(updatevalues.end_date),
                    }"
                    required
                  />

                  <!-- Buttons -->
                  <div class="flex w-full sm:w-[30%]">
                    <!-- Zoom button -->
                    <button
                      v-if="activeZoom"
                      type="button"
                      class="w-full rounded-xl text-sm p-2 text-white"
                      :class="
                        isClassEnded(updatevalues.end_date)
                          ? 'bg-gray-300 cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer'
                      "
                      @click="
                        !isClassEnded(updatevalues.end_date) &&
                          generateZoomUrlEdit()
                      "
                      :disabled="isClassEnded(updatevalues.end_date)"
                    >
                      Generate URL
                    </button>

                    <!-- Teams button -->
                    <button
                      v-else-if="activeTeams"
                      type="button"
                      class="w-full rounded-xl text-sm p-2 text-white"
                      :class="
                        isClassEnded(updatevalues.end_date)
                          ? 'bg-gray-300 cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer'
                      "
                      @click="
                        !isClassEnded(updatevalues.end_date) &&
                          generateUrlEdit()
                      "
                      :disabled="isClassEnded(updatevalues.end_date)"
                    >
                      Generate URL
                    </button>

                    <!-- Config Settings button -->
                    <button
                      v-else
                      type="button"
                      @click="reDirect()"
                      class="w-full rounded-xl text-sm p-2 whitespace-nowrap text-white"
                      :class="
                        !isFirst3FieldsFilled ||
                        isClassEnded(updatevalues.end_date)
                          ? 'bg-gray-300 text-gray-400 cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer'
                      "
                      :disabled="
                        !isFirst3FieldsFilled ||
                        isClassEnded(updatevalues.end_date)
                      "
                    >
                      Config Settings
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="flex flex-col gap-3 p-2 rounded-lg"
                :class="{
                  'border bg-[#F9FAFC]': !isClassEnded(updatevalues.end_date),
                  'border-gray-300 bg-white': isClassEnded(
                    updatevalues.end_date,
                  ),
                }"
              >
                <!-- Warning Section -->
                <div
                  v-if="!isClassEnded(updatevalues.end_date)"
                  class="flex items-center gap-2 p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-yellow-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <p class="font-bold text-sm">
                    Warning:
                    <span class="font-normal"
                      >Class Ended ({{ formatDateTime(updatevalues.end_date) }})
                      Upload is disabled.</span
                    >
                  </p>
                </div>

                <!-- Form Section -->
                <div class="w-full">
                  <form
                    enctype="multipart/form-data"
                    class="flex flex-col gap-2 w-full"
                    method="POST"
                    @submit.prevent="
                      uploadFilebyChunkNew('fileuploadvideo', 'video_url')
                    "
                  >
                    <label class="font-bold text-sm"
                      >Select video file to upload.</label
                    >

                    <div class="flex flex-row gap-2 w-full">
                      <input
                        type="file"
                        placeholder="Select Video"
                        class="bg-gray-100 w-[70%] md:w-full rounded-lg p-2 md:p-3 border-none outline-none"
                        accept="video/*"
                        id="fileuploadvideo"
                        @change="CheckVideoSizeUpload"
                        :disabled="!isClassEnded(updatevalues.end_date)"
                      />
                      <input
                        type="submit"
                        value="Upload"
                        id="submit"
                        :class="[
                          'rounded-lg text-xs md:text-sm font-bold p-2 md:px-4 md:py-2 cursor-pointer',
                          isClassEnded(updatevalues.end_date)
                            ? 'bg-blues text-white hover:bg-hover'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed',
                        ]"
                        :disabled="!isClassEnded(updatevalues.end_date)"
                      />
                    </div>

                    <p v-if="video_error" style="color: red">
                      {{ video_error }}
                    </p>
                  </form>

                  <div id="statusCode" class="mt-2"></div>
                </div>

                <!-- Existing Recording Link -->
                <a
                  :href="updatevalues.permanent_url"
                  v-if="updatevalues.permanent_url"
                  target="blank"
                  class="text-textblues hover:text-blue-600 text-sm"
                >
                  Existing Uploaded link.
                </a>

                <!-- Input for link -->
                <input
                  id="video_url"
                  type="text"
                  v-model="updatevalues.permanent_url"
                  placeholder="Select Link URL"
                  class="rounded-lg text-sm w-full p-3 border-none outline-none border bg-[#F9FAFC]"
                  :disabled="!isClassEnded(updatevalues.end_date)"
                />
              </div>

              <div class="flex justify-end gap-3 items-center">
                <button
                  type="submit"
                  :disabled="disable_submit"
                  :class="
                    disable_submit
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'hover:bg-hover text-black border border-black cursor-pointer hover:text-white'
                  "
                  class="rounded-lg text-sm px-6 py-2"
                >
                  Update
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        v-if="eventInfo"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="w-[95%] sm:w-[85%] md:w-[60%] 2xl:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div
            class="flex items-center justify-between mb-6 pb-4 border-b border-gray-200"
          >
            <div class="flex items-center gap-3">
              <!-- Course Icon -->
              <div
                class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-md"
              >
                <svg
                  class="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>

              <!-- Title Section -->
              <div>
                <h3 class="text-xl font-bold text-gray-800">
                  {{ this.eventInfoData.event.course_title }}
                </h3>
                <p class="text-xs text-gray-500 mt-0.5">Course Details</p>
              </div>
            </div>

            <!-- Close Button -->
            <button
              @click="eventInfo = false"
              class="p-1 border border-red-500 hover:bg-red-500 hover:border-red-500 rounded-full transition-all duration-200 group"
            >
              <svg
                class="w-5 h-5 text-red-400 group-hover:text-white transition-all duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
          >
            <div class="w-full">
              <div
                ref="ScheduleEvent"
                class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full w-full"
              >
                <div
                  class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label for="title" class="text-left font-bold">Title</label>
                    <p>{{ this.eventInfoData.title }}</p>
                  </div>
                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left font-bold"
                      >Start Time</label
                    >
                    <p>
                      {{
                        eventInfoData.start &&
                        eventInfoData.start.format("DD/MM/YYYY")
                      }}
                      (
                      {{
                        eventInfoData.start && eventInfoData.start.formatTime()
                      }}
                      <span v-if="eventInfoData.start.getHours() >= 12"
                        >PM</span
                      >
                      <span v-else>AM</span>
                      )
                    </p>
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left font-bold"
                      >End Time</label
                    >
                    <p>
                      {{
                        eventInfoData.end &&
                        eventInfoData.end.format("DD/MM/YYYY")
                      }}
                      (
                      {{ eventInfoData.end && eventInfoData.end.formatTime() }}
                      <span v-if="eventInfoData.start.getHours() >= 12"
                        >PM</span
                      >
                      <span v-else>AM</span>
                      )
                    </p>
                  </div>
                </div>

                <div class="w-full flex flex-col gap-2">
                  <div class="w-auto flex flex-row">
                    <a
                      :href="eventInfoData.contentFull"
                      target="_blank"
                      class="text-sm mt-1 bg-blues hover:bg-hover text-white px-3 py-2 rounded-xl"
                    >
                      Join Link
                    </a>
                  </div>
                </div>
                <div class="video-section">
                  <h3 class="text-sm font-bold mb-2">Meeting Records Link</h3>

                  <a
                    v-if="eventLink"
                    :href="eventLink"
                    target="blank"
                    class="download-link text-textblues hover:text-blue-600 flex gap-2 items-center text-sm"
                    download
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                      ></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Link
                  </a>

                  <p v-else class="no-link text-sm">⏳ No Link</p>
                </div>

                <div class="flex justify-end pb-4 mt-3 gap-x-10">
                  <button
                    @click="
                      updatevalues = eventInfoData.event;
                      popUp = true;
                    "
                    class="rounded-lg text-sm px-6 py-2 hover:bg-hover text-black border border-black cursor-pointer hover:text-white"
                  >
                    Update
                  </button>
                  <button
                    @click="
                      titlepass = eventInfoData.title;
                      popupwindow = true;
                      idpass = eventInfoData.id;
                    "
                    class="rounded-lg text-sm px-6 py-2 hover:bg-hover text-black border border-black cursor-pointer hover:text-white"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import SideBar from "@/components/Admin/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import FlashMessage from "@/components/FlashMessage.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";

export default {
  components: {
    Header,
    SideBar,
    VueCal,
    ConfirmPopup,
    FlashMessage,
  },
  data() {
    return {
      courseInfo: null,
      calendarInfo: null,
      scheduleDetails: null,
      popUp: false,
      updatevalues: null,
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: "",
      idpass: "",
      addevent: false,
      activeView: "month",
      eventInfo: false,
      eventInfoData: "",
      values: [],
      generatedUrl: "",
      disable_submit: false,
      isContainAccessToken: localStorage.getItem("access_token"),
      meetingUrl: "",
      formData: {
        coursetitle_id: "",
        title: "",
        startDate: "",
        endDate: "",
        feedback: "",
      },
      providers: [],
      msalInstance: null,
      video_error: "",
      chunkSize: 1024 * 1024,
      chunkIndex: 0,
      totalChunks: 0,
      file: null,
      title: "Sample Video",
      courses: [],
    };
  },

  created() {
    this.getcourse();
    this.getmeeting();
  },

  computed: {
    ...mapGetters(["userInfo"]),

    today() {
      const now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      return now.toISOString().slice(0, 16);
    },
    isFirst3FieldsFilled() {
      return (
        this.formData.coursetitle_id &&
        this.formData.title &&
        this.formData.startDate &&
        this.formData.endDate
      );
    },
    isButtonEnabled() {
      return this.isFirst3FieldsFilled && this.meetingUrl.length <= 20;
    },

    isAllFieldsFilled() {
      return (
        this.formData.coursetitle_id &&
        this.formData.title &&
        this.formData.startDate &&
        this.formData.endDate &&
        this.meetingUrl
      );
    },

    minDate() {
      return new Date().subtractDays(5);
    },
    activeZoom() {
      return this.providers.find(
        (item) => item.title === "Zoom" && item.active === true,
      );
    },
    activeTeams() {
      return this.providers.find(
        (item) => item.title === "Teams" && item.active === true,
      );
    },
    eventLink() {
      return (
        this.eventInfoData.event.permanent_url ||
        this.eventInfoData.event.recording
      );
    },
  },

  async mounted() {
    await this.getinfos();

    if (localStorage.getItem("access_token")) {
      this.removeTokenIfNotValid();
    }
    try {
      this.msalInstance = await this.$initMsal(this.userInfo.token_key);
    } catch (error) {
      console.error("Failed to initialize MSAL:", error);
    }
  },

  methods: {
    async getcourse() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/title/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.courses = response.data.data;
          } else {
            console.log("got error");
          }
        });
    },
    formatDateTime(dateString) {
      if (!dateString) return "N/A";
      const options = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };
      return new Date(dateString).toLocaleString(undefined, options);
    },
    isClassEnded(endDateString) {
      const endDate = new Date(endDateString);
      const now = new Date();
      return now > endDate;
    },
    uploadFilebyChunkNew(file_id, append_id) {
      const fileInput = document.getElementById(`${file_id}`);

      const file = fileInput.files[0];

      if (!file) {
        alert("Please select a file.");
        return;
      }

      this.file = file;
      this.totalChunks = Math.ceil(file.size / this.chunkSize);
      this.chunkIndex = 0;

     

      this.sendChunk(append_id);
    },

    sendChunk(append_id) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(this.file.size, start + this.chunkSize);
      const chunk = this.file.slice(start, end);

    

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", this.file.name);
      formData.append("chunkIndex", this.chunkIndex);
      formData.append("totalChunks", this.totalChunks);
      formData.append("title", this.title);

      for (let pair of formData.entries()) {
        console.log(pair[0], ":", pair[1]);
      }

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/video_uploader/chunk/`,
        true,
      );

      xhr.onload = () => {
      

        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);

          document.getElementById("statusCode").innerText = response.message;
          if (response.video_url) {
            const fullUrl = response.video_url;
            document.getElementById(`${append_id}`).value = fullUrl;
          }

          this.chunkIndex++;

          if (this.chunkIndex < this.totalChunks) {
            this.sendChunk(append_id);
          } else {
            alert("Upload complete!");
            console.log("Upload complete for file:", this.file.name);
          }
        } else {
          alert("Upload failed: " + xhr.responseText);
          console.error("Upload failed:", xhr.responseText);
        }
      };

      xhr.onerror = (err) => {
        console.error("XHR error:", err);
        alert("Upload error. Check console for details.");
      };

      xhr.send(formData);
    },
    videoUploadURL(id, bar_url) {
     

      var uploader = new FileUpload(
        document.querySelector(`#${id}`),
        bar_url,
        this,
      );

      uploader.upload("video_url");
    },
    handleFileUpload(event) {
      this.thumbnailFile = event.target.files[0];
    },
    reDirect() {
      alert("Please configure the meeting settings");
      setTimeout(() => {
        this.$router.push({
          path: "/profile",
          query: { tab: "meeting-settings" },
        });
      }, 500);
    },
    async generateUrl() {
      try {
        if (!this.msalInstance) {
          this.msalInstance = await this.$initMsal(this.userInfo.token_key);
        }
        const response = await this.msalInstance.loginPopup({
          scopes: ["User.Read", "OnlineMeetings.ReadWrite", "offline_access"],
        });
        if (response.accessToken) {
          localStorage.setItem("access_token", response.accessToken);
          this.isContainAccessToken = response.accessToken;
          await this.generateMeetingUrl();
        } else {
          console.log("Access token not received");
        }
      } catch (err) {
        console.error("MSAL login failed:", err);
        alert("Authentication failed: " + err.message);
      }
    },
    async getmeeting() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/user-meetings-keys/get/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.providers = response.data.data;
          } else if (response.data.status == 400) {
            this.providers = [];
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    generateZoomUrl() {
      if (!this.activeZoom) {
        alert("Zoom is not active");
        return;
      }
      const title = this.formData.title;
      const start = this.formData.startDate;
      const end = this.formData.endDate;
      if (!title || !start || !end) {
        alert("Enter meeting title, start time and end time.");
        return;
      }

      const startUTC = new Date(start).toISOString();
      const endUTC = new Date(end).toISOString();
      const payload = {
        subject: title,
        startDateTime: startUTC,
        endDateTime: endUTC,
        zoom_client_id: this.activeZoom?.value?.zoom_client_id || "",
        zoom_client_secret: this.activeZoom?.value?.zoom_client_secret || "",
        zoom_account_id: this.activeZoom?.value?.zoom_account_id || "",
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/zoom/create-meeting/?Key=${this.userInfo.token_key}`,
          payload,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.meetingUrl = response.data.zoom_join_url;
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
          }
        })
        .finally(() => {
          this.disable_submit = false;
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 1500);
        });
    },
    generateZoomUrlEdit() {
      let title = this.updatevalues.title;

      let timedetails = this.updatevalues.start_date;
      timedetails = timedetails.replaceAll("T", " ");

      let timedetailsEnd = this.updatevalues.end_date;
      timedetailsEnd = timedetailsEnd.replaceAll("T", " ");

      let payload = {
        subject: title,
        startDateTime: timedetails,
        endDateTime: timedetailsEnd,
        zoom_client_id: this.activeZoom?.value?.zoom_client_id || "",
        zoom_client_secret: this.activeZoom?.value?.zoom_client_secret || "",
        zoom_account_id: this.activeZoom?.value?.zoom_account_id || "",
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/zoom/create-meeting/?Key=${this.userInfo.token_key}`,
          payload,
        )
        .then((response) => {
          if (response) {
            const joinUrl = response.data.zoom_join_url;

            this.updatevalues.url = joinUrl;
          }
        })
        .catch((error) => {
          console.log(error, "error:::");
        });
    },
    removeTokenIfNotValid() {
      let convert_string = {
        subject: "test is access token valid",
        startDateTime: new Date().toISOString(),
        endDateTime: new Date().toISOString(),
      };

      axios
        .post(
          `https://graph.microsoft.com/v1.0/me/onlineMeetings`,
          convert_string,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          },
        )
        .then((response) => {
          if (response.status == 401) {
            console.log("token expired.");
          }
        })
        .catch((error) => {
          if (error.status == 401) {
            if (localStorage.getItem("access_token")) {
              localStorage.removeItem("access_token");
            }
          }
        });
    },

    onEventClick(event, e) {
      this.eventInfo = true;
      this.eventInfoData = event;
    },

    async getinfos() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?Key=${this.userInfo.token_key}`,
        )
        .then((Response) => {
          this.courseInfo = Response.data.data;
        });

      await axios
        .get(
          `${process.env.VUE_APP_API}/calendar/view/?Key=${this.userInfo.token_key}`,
        )
        .then((Response) => {
          if (Object.keys(Response.data) == "error") {
            this.values = [];
            console.log("Null");
          } else {
            this.calendarInfo = Response.data.data;
            this.values = [];
            this.calendarInfo.forEach((element) => {
              let startdate = new Date(element.start_date);
              let enddate = new Date(startdate);

              enddate = new Date(
                enddate.setMinutes(startdate.getMinutes() + 30),
              );

              let tempvar = {
                start: element.start_date,
                end: element.end_date,
                title: element.title,
                class: "Progressive",
                contentFull: element.url,
                id: element.id,
                event: element,
              };
              this.values.push(tempvar);
            });
            console.log(this.values);
          }
        });
    },

    async deleteEvents(id) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/calendardeleted/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Event Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      this.popupwindow = false;
      this.eventInfo = false;
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.getinfos();
      }, 1500);
    },
    closeAddForm() {
      this.addevent = false;
      this.formData = {
        title: "",
        startDate: "",
        endDate: "",
      };
      this.meetingUrl = "";
      if (this.$refs.ScheduleEvent) {
        this.$refs.ScheduleEvent.reset();
      }
    },
    async editEvents(el) {
      this.disable_submit = true;
      let updatedEditInfo = new FormData();

      updatedEditInfo.append("title", this.updatevalues.title);
      updatedEditInfo.append(
        "organization_id",
        this.updatevalues.organization_id,
      );
      updatedEditInfo.append("user", this.updatevalues.user);
      updatedEditInfo.append("status", this.updatevalues.status);
      updatedEditInfo.append("url", this.updatevalues.url);
      updatedEditInfo.append("start_date", this.updatevalues.start_date);
      updatedEditInfo.append("end_date", this.updatevalues.end_date);
      updatedEditInfo.append("feedback", this.updatevalues.feedback);
      updatedEditInfo.append("duration", this.updatevalues.duration);
      updatedEditInfo.append("course_data",  this.updatevalues.course_data);
      if (this.thumbnailFile) {
        updatedEditInfo.append("image", this.thumbnailFile);
      }
      if (el.target.elements.video_url && el.target.elements.video_url.value) {
        updatedEditInfo.append(
          "permanent_url",
          el.target.elements.video_url.value,
        );
      }

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/calendarupdated/${this.updatevalues.id}/?Key=${this.userInfo.token_key}`,
          updatedEditInfo,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: "Event Updated successfully",
            type: "success",
          };
        } else {
          this.messages = { text: "Event Failed", type: "error" };
        }
      } catch (error) {
        console.error(error);
        this.messages = {
          text: "Event Failed. Please try again.",
          type: "error",
        };
      } finally {
        setTimeout(async () => {
          this.messages = { text: "", type: "null" };
          this.popUp = false;
          this.updatevalues = null;
          this.eventInfo = false;
          this.disable_submit = false;
          await this.getinfos();
        }, 2500);
      }
    },

    async generateMeetingUrl() {
      const title = this.formData.title;
      const start = this.formData.startDate;
      const end = this.formData.endDate;

      if (!title || !start || !end) {
        alert("Enter meeting title, start time and end time.");
        return;
      }

      const startUTC = new Date(start).toISOString();
      const endUTC = new Date(end).toISOString();

      const payload = {
        subject: title,
        startDateTime: startUTC,
        endDateTime: endUTC,
      };

      try {
        const response = await axios.post(
          `https://graph.microsoft.com/v1.0/me/onlineMeetings`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          },
        );

        if (response && response.data.joinUrl) {
          this.meetingUrl = response.data.joinUrl;
        }
      } catch (error) {
        console.error("Error generating URL:", error);
        alert(
          "Failed to generate meeting URL: " +
            (error.response?.data?.error?.message || error.message),
        );
      }
    },

    generateUrlOldHave() {
      this.disable_submit = true;
      let title = document.getElementById("meetingTitle").value;
      let durations = document.getElementById("duration").value;
      let timedetails = document.getElementById("meetingDate").value;
      timedetails = timedetails.replaceAll("T", " ");
      let inputdatas = {
        topic: title,
        start_time: timedetails,
        agenda: title,
        duration: durations,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/zoom/?Key=${this.userInfo.token_key}`,
          inputdatas,
        )
        .then((response) => {
          this.generatedUrl = response.data.datzoom_join_urla;
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    generateUrlEdit() {
      let title = this.updatevalues.title;

      let timedetails = this.updatevalues.start_date;
      timedetails = timedetails.replaceAll("T", " ");

      let timedetailsEnd = this.updatevalues.end_date;
      timedetailsEnd = timedetailsEnd.replaceAll("T", " ");

      let convert_string = {
        subject: title,
        startDateTime: timedetails,
        endDateTime: timedetailsEnd,
      };

      axios
        .post(
          `https://graph.microsoft.com/v1.0/me/onlineMeetings`,
          convert_string,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          },
        )
        .then((response) => {
          if (response) {
            this.generatedUrl = response.data.joinUrl;
          }
        })
        .catch((error) => {
          console.log(error, "error:::");
        });
    },

    async scheduledate(el) {
      this.disable_submit = true;

      let Urls = this.meetingUrl;
      let timedetails = this.formData.startDate.replaceAll("T", " ");
      let timedetailsEnd = this.formData.endDate.replaceAll("T", " ");

      let HeaderVal = new FormData();

      HeaderVal.append("title", this.formData.title);
      HeaderVal.append("organization_id", this.userInfo.organizes_id);
      HeaderVal.append("user", this.userInfo.user.id);
      HeaderVal.append("status", true);
      HeaderVal.append("url", Urls);
      HeaderVal.append("start_date", timedetails);
      HeaderVal.append("end_date", timedetailsEnd);
      HeaderVal.append("course_data", this.formData.coursetitle_id);

      HeaderVal.append("feedback", this.formData.feedback ? "True" : "False");

      if (el.target.elements.thumbnail.files.length > 0) {
        let thumbnailVal = el.target.elements.thumbnail.files[0];
        HeaderVal.append("image", thumbnailVal);
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/calendar_new/?Key=${this.userInfo.token_key}`,
          HeaderVal,
        );

        this.scheduleDetails = response.data;

        if (this.scheduleDetails.status == 200) {
          this.messages = { text: "Event Added successfully", type: "success" };
        } else {
          this.messages = { text: "Event Failed", type: "error" };
        }

        // Reset fields
        this.formData = { title: "", startDate: "", endDate: "" };
        this.meetingUrl = "";
        this.$refs.ScheduleEvent.reset();

        // reload data
        this.getinfos();
        this.addevent = false;

        setTimeout(() => {
          this.generatedUrl = "";
          this.messages = { text: "", type: null };
        }, 1500);
      } catch (error) {
        console.error("Schedule Error:", error);
        this.messages = { text: "Request failed!", type: "error" };
        setTimeout(() => {
          this.messages = { text: "", type: null };
        }, 1500);
      } finally {
        // Always executed
        this.disable_submit = false;
      }
    },
    closeAddForm() {
      this.addevent = false;
      this.formData = {
        coursetitle_id: "",
        title: "",
        startDate: "",
        endDate: "",
      };
      this.meetingUrl = "";
      if (this.$refs.ScheduleEvent) {
        this.$refs.ScheduleEvent.reset();
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

.vuecal--blue-theme {
  border-radius: 50px;
  background-color: white;
  position: relative;
  border: none !important;
}

.vuecal__event {
  color: #115e59;
  background-color: #f5f5f5;
  border: 1px dashed #ba0606;
  overflow: hidden;
}
.vuecal__cell-content {
  height: 180px;
}
.vuecal__event.Progressive {
  background-color: #0f766e;
  border-radius: 6px;
  border: 1px solid rgb(248, 247, 247);
  color: #fff;
}
.vuecal--short-events .vuecal__event-title {
  font-size: 0.8em;
  text-align: center;
}
.vuecal__cell-events {
  height: 180px;
  overflow: scroll;
  scrollbar-color: white transparent;
  cursor: pointer;
}

.vuecal__cell-content::-webkit-scrollbar {
  width: 8px;
}

.vuecal__cell-content::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 15px;
}

.vuecal__cell-content::-webkit-scrollbar-track {
  background: #fff;
}
</style>
